<template>
  <div>
    <div id="app" class="md-layout md-alignment-top-space-around md-app-container">
      <div>
        <img id="logo" src="./assets/logo.png" alt="FUN LEARN Logo"/>
      </div>
      <div id="txt-1" class="text-bg">
        <div>
          Finde hier deine nächste<br>
          FUN LEARN-Fahrschule.
        </div>
      </div>
      <div id="plz-input">
        <form @submit.prevent="handleSubmit">
          <input type="text" v-model="plz" placeholder="PLZ"/>
        </form>
      </div>
      <div id="btn-1" v-on:click="handleSubmit">
        <img src="./assets/button_1.png"/>
      </div>

      <div id="txt-2" class="text-bg">
        <div>
          Du möchtest<br>
          FUN LEARN-Fahrschule<br>
          werden?
        </div>
      </div>
      <div id="btn-2">
        <a target="_blank" href="https://gecco-fahrschulen.de/fahrschule/kontakt/">
          <img src="./assets/button_2.png"/>
        </a>
      </div>
    </div>
    <div id="footer">
      <a target="_blank" href="https://gecco-fahrschulen.de/fahrschule/impressum/">Impressum</a> |
      <a target="_blank" href="https://gecco-fahrschulen.de/fahrschule/datenschutz-agb/">Datenschutz</a>
    </div>
    <md-dialog-alert
      :md-active.sync="noZip"
      md-content="Die Postleitzahl wurde leider nicht gefunden!"
      md-confirm-text="OK" />
    <md-dialog-alert
      :md-active.sync="noResult"
      md-content="Im Umkreis von 50km zu deiner eingegebenen PLZ gibt es leider aktuell keine Fahrschule, die dir FUN LEARN&reg; anbieten kann.<br>Bitte versuche es mit einer anderen PLZ noch einmal."
      md-confirm-text="OK" />
  </div>
</template>

<script>
import {HTTP} from './http-common'

export default {
  name: 'App',
  data: () => ({
    plz: '',
    noZip: false,
    noResult: false
  }),
  methods: {
    handleSubmit: function () {
      if (this.plz.length >= 4) {
        HTTP.get('/funlearn/search/' + this.plz)
          .then((response) => {
            if (response.data.status === 'no-zip') {
              this.noZip = true
            }
            if (response.data.status === 'no-result') {
              this.noResult = true
            }
            if (response.data.status === 'ok') {
              window.location = 'http://' + response.data.data
            }
          })
          .catch((error) => {
            console.log(error)
          })
      }
    }
  }
}
</script>

<style>
body {
  font-family: 'Raleway', sans-serif;
  color: #ffffff;
}

a {
  color: #ffffff !important;
}

#app{
  width: 100%;
  background-image: url("./assets/background.jpg");
  background-size: cover;
  background-repeat: no-repeat;
  margin: auto;
  min-height: 1080px;
}
#footer{
  width: 100%;
  background-color: #312783;
  margin: auto;
  height: 80px;
  text-align: center;
  padding-top: 25px;
  font-size: 16px;
}

#logo {
  width: 100%;
  max-width: 400px;
  position: absolute;
  left: 1.25%;
  top: 20px;
}

#txt-1 {
  background-image: url("./assets/text_1.png");
  width: 100%;
  position: absolute;
  top: 35%;
  left: 1.25%;
  padding: 25px 0 0 30px;
}
#plz-input {
  position: absolute;
  top: 49%;
  left: 7%;
  width: 300px;

  /* Rotate in all browsers */
  -webkit-transform: rotate(-7deg);
  -moz-transform: rotate(-7deg);
  -ms-transform: rotate(-7deg);
  -o-transform: rotate(-7deg);
}
#plz-input input {
  border: none;
  width: 100%;
  height: 35px;
  padding: 15px 10px 10px 10px;
  color: darkgray;
  font-weight: bold;
  font-size: 1.5em;
}

::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: darkgray;
  font-weight: bold;
  opacity: 1; /* Firefox */
}

:-ms-input-placeholder { /* Internet Explorer 10-11 */
  color: darkgray;
  font-weight: bold;
}

::-ms-input-placeholder { /* Microsoft Edge */
  color: darkgray;
  font-weight: bold;
}

#btn-1 {
  position: absolute;
  width: 250px;
  height: 6.56%;
  top: 52%;
  left: 14%;
  cursor: pointer;
}
#btn-1 img {
  width: 100%;
}

#txt-2 {
  background-image: url("./assets/text_2.png");
  width: 100%;
  position: absolute;
  top: 70%;
  left: 5%;
  padding: 15px 0 0 30px;
}

#btn-2{
  left: 10%;
  width: 250px;
  position: absolute;
  top: 87%;
}
#btn-2 img {
  width: 100%;
}

.text-bg {
  background-size: contain;
  background-repeat: no-repeat;
  height: 15%;
}
.text-bg div {
  color: #ffffff;
  font-size: 24px;
  line-height: 1em;
  font-weight: bold;

  /* Rotate in all browsers */
  -webkit-transform: rotate(-7deg);
  -moz-transform: rotate(-7deg);
  -ms-transform: rotate(-7deg);
  -o-transform: rotate(-7deg);
}

@media screen and (min-width: 1600px) {
  #app, #footer {
    width: 1600px;
  }
}

@media screen and (min-width: 700px) {
  #txt-1 {
    width: 513px;
    padding: 35px 0 0 30px;
  }
  #txt-2 {
    width: 685px;
    padding: 5px 0 0 30px;
  }
  .text-bg div {
    font-size: 34px;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue